import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import ServiciosComponent from "../componentes/servicios/index";
import RedesComponent from "../../utilerias/redesSociales";
import "./styles.css";

export class Servicios extends Component {
  render() {
    return (
      <Fragment>
        <div className="servicios-fondo">
          <ServiciosComponent
            componente={this.props.componente}
            idiomaNavegador={this.props.idiomaNavegador}
            servicios={this.props.servicios}
          ></ServiciosComponent>
          <RedesComponent></RedesComponent>
        </div>
      </Fragment>
    );
  }
}

Servicios.propTypes = {
  servicios: PropTypes.array,
  idiomaNavegador: PropTypes.string,
  componente: PropTypes.string,
};

export default Servicios;
